<section class="p-3">
  <p-card>
    <div class="d-flex flex-column justify-content-between mb-4">
      <h2 class="title m-0">Alarmas</h2>
      <strong class="my-3"
        >*FUGA CONSTANTE : - Posibles pequeñas fugas sostenidas (cisterna que gotea, fuga en grifo o
        tubería oculta)- Se produce cuando el caudal constante en 24 horas es superior a 1% de Q3
        para DN 13 a DN 20 y superior a un 0,25% para DN superiores a 25. Desaparece al cabo de 1
        hora, si el caudal constante en esa hora es inferior al 1/0,5/0,25% de Q3. Puede consultar
        el Q3 en su contador .</strong
      >
      <strong class="mb-3"
        >*FUGA IMPORTANTE : - Consumo elevado constante (ducha abierta, fuga importante,
        electrodoméstico defectuoso). NOTA: puede verse también durante llenados de piscinas o
        depósitos privados. Para una correcta identificación acuda a ver su histórico horario de
        consumo- Se produce cuando el caudal constante en 60 minutos es superior al 10% de Q3 para
        DN 13 a DN 20 y superior a un 5% para DN superiores a 25. Desaparece a los 32 segundos, si
        el caudal constante en ese periodo de tiempo es inferior al 20/10/5% de Q3. Puede consultar
        el Q3 en su contador.</strong
      >

      <!-- <button 
      class="btn btn-sm d-flex align-items-center gap-2"
      [class.btn-primary-primary]="onlyActive()"
      [class.btn-outline-primary]="!onlyActive()"
      (click)="toggleFilter()">
      <i class="pi" [ngClass]="onlyActive() ? 'pi-check-circle' : 'pi-filter'"></i>
      {{ onlyActive() ? 'Solo activas' : 'Ver historial completo' }}
    </button> -->

      <p-button
        class="ms-auto"
        (onClick)="toggleFilter()"
        [outlined]="!onlyActive()"
        severity="primary"
        [label]="onlyActive() ? 'Solo activas' : 'Ver historial completo'"
        [icon]="onlyActive() ? 'pi pi-check-circle' : 'pi pi-filter'"
      />
    </div>

    <p-table [value]="$alarms.alarms()" [breakpoint]="'960px'">
      <ng-template pTemplate="header">
        <tr>
          <th>Contador</th>
          <th>Descripción</th>
          <th>Fecha Inicio</th>
          <th>Fecha Desactivación</th>
          <th class="text-center">Estado</th>
          <th width="100px"></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-alarm>
        <tr [ngClass]="{ 'opacity-50': alarm.expiredAt }">
          <td>
            {{ alarm.meterSerialNumber }}
          </td>
          <td>
            {{ alarm.type.description }}
          </td>
          <td>
            {{ alarm.createdAt | date: 'dd/MM/yyyy HH:mm' }}
          </td>
          <td>
            {{ alarm.expiredAt | date: 'dd/MM/yyyy HH:mm' }}
          </td>
          <td class="text-center">
            @if (!alarm.expiredAt) {
              <p-tag severity="danger" value="ACTIVA" [rounded]="true"></p-tag>
            } @else {
              <p-tag severity="secondary" value="CERRADA" [rounded]="true"></p-tag>
            }
          </td>
          <td class="text-end">
            <p-button
              label="Abrir"
              [text]="true"
              [rounded]="true"
              severity="secondary"
              (onClick)="openHistoric(alarm)"
            />
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5" class="text-center p-4">No se encontraron alarmas registradas.</td>
        </tr>
      </ng-template>
    </p-table>
    @if ($alarms.alarmsTotalElements() > 0) {
      <p-paginator
        (onPageChange)="onPageChange($event)"
        [first]="currentPage() * $alarms.alarmsPageSize"
        [rows]="$alarms.alarmsPageSize"
        [totalRecords]="$alarms.alarmsTotalElements()"
      />
    }
  </p-card>

  <app-alarms-historic (alarmDeactivated)="refreshAlarms()" />
</section>
